import React, { useState } from 'react';
import { Heading, UserInterfaceTag, ExtendedTheme, Link, ArrowsChevronSmallDown } from 'neon-design-system';
import LinkList, { ListItemOrientation,  ListItemType } from './LinkList';
import { makeStyles, createStyles } from '@material-ui/core';
import { IdAndName } from '../../shared/types';
import { baseUrls } from '../../utils/baseUrls.utils';

interface TagList {
	tags?: IdAndName[];
	showTwoRowsOnly?: boolean;
	disableSort?: boolean;
}

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) => createStyles({
	title: {
		marginBottom: theme.spacing(2)
	},
	linkWrapper: {
		display: 'flex',
		marginTop: theme.spacing(2)
	},
	link: {
		display: 'flex',
		alignItems: 'center',
		fontWeight: 'bold'
	},
	icon: {
		marginLeft: theme.spacing(0.5)
	}
}));

export const ArticleTagList = ({ tags = [], showTwoRowsOnly = false, disableSort = true }: TagList) => {
	const classes = useStyles();
	const [moreTagsShown, setMoreTagsShown] = useState(false);
	if (!tags.length) {
		return null;
	}

	const tagsToRender = tags.map(({ _id, name }) => {
		return (
			{
				id: _id,
				name,
				url: `${baseUrls.tag.main}/${_id}`,
				icon: <UserInterfaceTag/>
			}
		);
	});
	const numberOfTagsInTwoRows = 5;
	const tagsToShow = !moreTagsShown ? tagsToRender.slice(0, numberOfTagsInTwoRows): tagsToRender;
	const displayShowAllLink = showTwoRowsOnly && !moreTagsShown && tagsToRender.length > numberOfTagsInTwoRows;

	return (
		<div>
			<Heading
				className={classes.title}
				styleName="title1"
				xs="small"
				md="medium"
				xl="large"
			>
				Tags
			</Heading>
			<div id={'article-page-tag-list'}>
				<LinkList
					items={!showTwoRowsOnly ? tagsToRender : tagsToShow}
					orientation={ListItemOrientation.Horizontal}
					displayType={ListItemType.Chip}
					disableSort={disableSort}
				/>
			</div>
			{
				displayShowAllLink && (
					<div className={classes.linkWrapper}>
						<Link
							className={classes.link}
							to=""
							onClick={(e) => {
								e.preventDefault();
								setMoreTagsShown(true);
							}}
						>
						Show all
							<ArrowsChevronSmallDown className={classes.icon} />
						</Link>
					</div>
				)
			}
		</div>
	);
};

export default ArticleTagList;
